export const DEFAULT_WIDGET_OPTIONS = [
  { value: 'dashboard', labelKey: 'tableau_de_bord' },
  { value: 'plan', labelKey: 'plan' },
  { value: 'graphe', labelKey: 'graphe' },
];

export const WIDGET_OPTION_MAP = DEFAULT_WIDGET_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

export const resolveWidgetOptions = (availableWidgets) => {
  if (!availableWidgets || availableWidgets.length === 0) {
    return DEFAULT_WIDGET_OPTIONS;
  }

  const resolved = availableWidgets
    .map((entry) => {
      if (typeof entry === 'string') {
        return WIDGET_OPTION_MAP[entry];
      }
      if (entry && entry.value) {
        const base = WIDGET_OPTION_MAP[entry.value] || {};
        return { ...base, ...entry };
      }
      return null;
    })
    .filter(Boolean)
    .map((option) => ({ ...option }));

  return resolved.length > 0 ? resolved : DEFAULT_WIDGET_OPTIONS;
};
